
// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import 'lightgallery/src/sass/lightgallery.scss';

import {
    jarallax,
    jarallaxVideo
} from 'jarallax';
import 'bootstrap';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    basicNavigation();

    jarallaxVideo();

    jarallax(document.querySelectorAll('.HomePage .parallax.intro'), {
        videoSrc: 'https://www.youtube.com/watch?v=QGAMTlI6XxY',
        videoStartTime: 35,
        videoEndTime: 120,
        speed: 0.5
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    setTimeout(function(){
        $('.video-background').addClass('d-none');
    }, 5000);

    /*
    $('.carousel.full-height .slick').slick({
        autoplay: true,
        autoplaySpeed: 10000,
        fade: true,
        arrows: false
    });
     */

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    // var swiper = new Swiper(".carousel", {
    //     loop: true,
    //     pagination: {
    //         el: ".swiper-pagination",
    //         clickable: true
    //     },
    // });

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if(window.innerWidth >= 1200) {
            if (scroll >= $('#contact-navigation').outerHeight()) {
                $('body').addClass('navbar-fixed');
            } else {
                $('body').removeClass('navbar-fixed');
            }
        } 
        else {
            if (scroll >= $('#mobile-phone').outerHeight()) {
                $('body').addClass('navbar-fixed');
            } else {
                $('body').removeClass('navbar-fixed');
            }
        }
    });

    $('.fb-insta-feed-post').attr('target', '_blank');

    if($('.fb-insta-feed-post').length === 5) {
        $('.fb-insta-feed-post').addClass('width-5-custom');
    }

    if($('.instagram-feed').length > 0) {
        const callback = function(mutationList, observer) {
            let added = [];
            mutationList.forEach(element => {
                added = element.addedNodes;
            });
            added.forEach((item, i) => {
                if(i >= 16) {
                    console.log(i)
                    if(item.nodeType === Node.ELEMENT_NODE) {
                        console.log(item)
                        $(item).addClass('d-none')
                    }
                }
            });
        }
        let observer = new MutationObserver(callback);
        var targetNode = $("#fb-insta-feed")[0];
        const config = { childList: true };
        observer.observe(targetNode, config)
    }


    // $('.elemental-sponsors .slick').slick({
    //     slidesToShow: 5,
    //     arrows: false,
    //     responsive: [
    //         {
    //             breakpoint: 1200,
    //             settings: {
    //                 arrows: false,
    //                 slidesToShow: 5
    //             }
    //         },
    //         {
    //             breakpoint: 992,
    //             settings: {
    //                 arrows: false,
    //                 slidesToShow: 4
    //             }
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 arrows: false,
    //                 slidesToShow: 2
    //             }
    //         }
    //     ]
    // });

    // $('.hail-carousel').each(function(index, element){
    //     //Build carousel options (from the Hail carousel DataObject)
    //     const slickOptions = {
    //         lazyLoad: 'ondemand',
    //         dots: ($(element).data('showdots') === "Yes"),
    //         slidesToShow: $(element).data('lg-toshow'),
    //         slidesToScroll: $(element).data('lg-toscroll'),
    //         responsive: [
    //             {
    //                 breakpoint: $(element).data('md-break'),
    //                 settings: {
    //                     slidesToShow: $(element).data('md-toshow'),
    //                     slidesToScroll: $(element).data('md-toscroll')
    //                 }
    //             },
    //             {
    //                 breakpoint: $(element).data('sm-break'),
    //                 settings: {
    //                     slidesToShow: $(element).data('sm-toshow'),
    //                     slidesToScroll: $(element).data('sm-toscroll'),
    //                     arrows: false
    //                 }
    //             }
    //         ]
    //     };

    //     $(element).slick(slickOptions);
    // });

});
